<fuse-card class="flex h-full flex-col">
  <div class="flex items-center gap-2 border-b px-4 py-3">
    <span class="flex-1 text-base font-semibold text-gray-900">Service Requests</span>
    <a role="button" (click)="viewAll()" class="cursor-pointer rounded border border-transparent px-2 py-0.5 text-sm text-gray-400 transition hover:border-gray-200 hover:text-primary">View all</a>
  </div>
  <div class="flex-1 overflow-y-auto">
    @if (dataLoader) {
      <div class="flex h-full items-center justify-center">
        <mat-spinner diameter="28" color="primary"></mat-spinner>
      </div>
    }
    @if (dataList?.length && !dataLoader) {
      @for (item of dataList; track item.id) {
        <div class="flex cursor-pointer flex-col gap-1 border-b px-4 py-1 last:border-b-0 hover:bg-gray-50" (click)="openRequestsModal($event, item)">
          <!-- Row 1: reference + status badge -->
          <div class="flex items-center justify-between gap-2">
            <span class="truncate text-sm font-semibold text-primary">{{ item.reference }}</span>
            <span [class]="'shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold ' + (item.status | badge)">{{ item.status }}</span>
          </div>
          <!-- Row 2: community · unit flags · date -->
          <div class="flex items-center gap-1.5 text-xs text-gray-400">
            <span class="truncate">{{ item.association?.name }}</span>
            @if (item.unit?.unit_number) {
              <span class="opacity-40">·</span>
              <span class="shrink-0">{{ item.unit?.unit_number }}</span>
              @if (item?.unit?.is_legal_notice_active) {
                <app-status-dot color="#f57c00" title="Legal Notice"></app-status-dot>
              }
              @if (item?.unit?.is_violation_active) {
                <mat-icon class="text-danger icon-size-4" fontIcon="warning" title="Active Violation Notice(s) Issued"></mat-icon>
              }
            }
            <span class="ms-auto shrink-0">{{ item.created_at | date: 'MMM d, y' }}</span>
          </div>
        </div>
      }
    }
    @if (!dataLoader && !dataList?.length && !error) {
      <div class="flex h-full flex-col items-center justify-center gap-2 text-gray-400">
        <mat-icon fontIcon="check_box_outline_blank" class="opacity-40 icon-size-8"></mat-icon>
        <span class="text-sm font-medium">No pending service requests</span>
      </div>
    }
  </div>
</fuse-card>
